/**
* Circle CTA JS
* -----------------------------------------------------------------------------
*
* All the JS for the Circle CTA component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    className: 'circle-cta',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      const btns = document.querySelectorAll( '.circle-cta__btn' );

      btns.forEach( ( btn ) => {
        const circleCta = btn.closest( '.circle-cta' );
        const circleBg = circleCta?.querySelector( '.circle-cta__content-wrapper-bg' );

        if ( !circleBg || !circleCta ) return;

        let isHovered = false;
        let targetScale = 1;

        const updateTargetScale = () => {
          const ctaRect = circleCta.getBoundingClientRect();
          const circleRect = circleBg.getBoundingClientRect();
          const circleRadius = circleBg.offsetWidth / 2;
          const circleCenterX = circleRect.left + ( circleRect.width / 2 );
          const circleCenterY = circleRect.top + ( circleRect.height / 2 );
          const corners = [
            [ctaRect.left, ctaRect.top],
            [ctaRect.right, ctaRect.top],
            [ctaRect.right, ctaRect.bottom],
            [ctaRect.left, ctaRect.bottom],
          ];

          const farthestCorner = Math.max( ...corners.map( ( [x, y] ) => (
            Math.hypot( x - circleCenterX, y - circleCenterY )
          ) ) );

          targetScale = Math.max( 1, ( farthestCorner / circleRadius ) * 1.02 );

          if ( isHovered ) {
            gsap.to( circleBg, {
              scale: targetScale,
              duration: 0.2,
              ease: 'power2.out',
            } );
          }
        };

        gsap.set( circleBg, {transformOrigin: 'center center'} );
        updateTargetScale();

        const resizeObserver = new ResizeObserver( updateTargetScale );
        resizeObserver.observe( circleCta );
        resizeObserver.observe( circleBg );

        btn.addEventListener( 'mouseenter', () => {
          isHovered = true;
          updateTargetScale();

          gsap.to( circleBg, {
            scale: targetScale,
            duration: 1,
            ease: 'power2.out',
          } );
        } );

        btn.addEventListener( 'mouseleave', () => {
          isHovered = false;

          gsap.to( circleBg, {
            scale: 1,
            duration: 0.8,
            ease: 'power2.inOut',
          } );
        } );
      } );
    },

    finalize: function() {},
  };

  app.registerComponent( 'circle-cta', COMPONENT );
} )( app );
